import type { WUploadedImageView } from '@zola/svc-web-api-ts-client';
import ApiService from '@zola-helpers/client/dist/es/http/api';

export const fetchImageMetadata = (imageUUID: string) => {
  return ApiService.get<WUploadedImageView>(`/web-api/v2/image/${imageUUID}/meta`);
};
